import React from 'react';
import Navbar from '../components/LandingPageNew/Navbar';
import ContactSection from '../components/Contact/Contact';
import Footer from '../components/LandingPageNew/Footer';
import SEO from '../components/Shared/SEO';
const Contact = () => {
  return (

    <>
    <SEO
            title="Kontaktiert uns noch heute | UNEVA "
            description="Jetzt Kontakt aufnehmen für Reputationsmanagement, Webdesign & 
Automatisierungen. Digitale Lösungen mit messbaren Ergebnissen. "
            canonical="https://uneva.de/kontakt"
          />
          <div className="relative min-h-screen">
          {/* Navbar on top of hero */}
          <Navbar />
          <ContactSection/>
    
          <Footer/>
          
        </div>
    </>
    
  );
};

export default Contact;
